<template functional>
    <h4 class="headline">
        {{props.title}}
    </h4>
</template>

<script>
export default {
    name: "headline",
    props: {
        title: {
            type: String,
            default: ""
        }
    }
}
</script>

<style scoped lang="less">
.headline {
    font-size: 24px;
    color: #2F3134;
    position: relative;
    margin: 30px 0;
    &::before {
        content: "";
        position: absolute;
        width: 6px;
        top: 3px;
        bottom: 0;
        left: -14px;
        background-color: #256CF4;
    }
}
</style>
